import DOMPurify from "isomorphic-dompurify";
import parse from "html-react-parser";

export const CONTENT_TYPES = {
  VIDEOS: "Videos",
  SPECIAL_REPORTS: "Special Reports",
  SPOTLIGHTS: "Spotlights",
  INFOBYTES: "Infobytes",
  ARTICLES: "Articles",
  NEWS: "News",
  OPINIONS: "Opinions",
  PODCAST_EPISODES: "Podcast Episodes",
  VIDEOS_AND_PODCAST_EPISODES: "Videos And Podcast Episodes",
  GUIDES: "Guides"
};

export const CONTENT_TYPES_SLUG = {
  "Videos": "videos",
  "Special Reports": "reports",
  "Spotlights": "spotlights",
  "Infobytes": "infobytes",
  "Articles": "articles",
  "News": "news",
  "Opinions": "opinions",
  "Podcast Episodes": "/podcasts-masterclasses",
  "Guides": "guides"
};

const YOUTUBE_URL = /^https?:\/\/(www\.|m\.)?(youtube\.com|youtu\.be)\//i;

export function isYouTubeUrl(url) {
  return YOUTUBE_URL.test(url || "");
}

// Play the YouTube copy when there is one, so plays count as YouTube views.
// video_url (self-hosted) stays the fallback and still feeds the audio
// version and the muted hover previews. A YouTube link without a video id
// (e.g. a bare youtube.com placeholder) falls back too.
export function getVideoPlaybackUrl(item) {
  return (
    (getYouTubeEmbedUrl(item?.youtube_url) && item.youtube_url) ||
    item?.video_url ||
    ""
  );
}

// The embed URL of a specific video, or null. Handles youtu.be/<id>,
// /watch?v=<id>, /shorts/<id>, /embed/<id> and /live/<id>.
export function getYouTubeEmbedUrl(url) {
  if (!isYouTubeUrl(url)) return null;
  try {
    const { hostname, pathname, searchParams } = new URL(url);
    const id =
      hostname === "youtu.be"
        ? pathname.split("/")[1]
        : searchParams.get("v") ||
          pathname.match(/^\/(shorts|embed|live)\/([^/?]+)/)?.[2];
    return id ? `https://www.youtube.com/embed/${id}` : null;
  } catch {
    return null;
  }
}

export function getContentTypeUuid(name, content_types) {
  if (content_types.length == 0) return null;

  return content_types.find(
    (content_type) => content_type.name.toLowerCase() == name.toLowerCase()
  );
}

export function cleanHTML(html) {
  const regex = /<a\s+href="(.*?)">/g;
  const output = html.replace(
    regex,
    '<a target="_blank" rel="noopener noreferrer nofollow" href="$1">'
  );

  const result = parse(
    DOMPurify.sanitize(output, {
      USE_PROFILES: { html: true },
      ADD_ATTR: ['target', 'allowfullscreen', 'frameborder', 'allow'],
      ADD_TAGS: ['iframe'],
      ALLOWED_TAGS: ['iframe', 'div', 'p', 'a', 'span', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'ul', 'ol', 'li', 'strong', 'em', 'br'],
      ALLOWED_ATTR: ['class', 'href', 'target', 'rel', 'src', 'title', 'allowfullscreen', 'frameborder', 'allow']
    })
  );
  return result;
}
